import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { ConfigPainelChamada, initialValueConfigPainelChamadaState, ConfigPainelChamadaState, ConfigPainelChamadaActions } from "./confpc.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppState } from "../root/root.model";

export interface ConfigPainelChamadaViewProps {
    configPainelChamadaState: ConfigPainelChamadaState
    configPainelChamadaActions: ConfigPainelChamadaActions
}


class ConfigPainelChamadaController extends Controller<ConfigPainelChamada, ConfigPainelChamadaState, ConfigPainelChamadaActions> {
    constructor() {
        super(initialValueConfigPainelChamadaState.row.type, initialValueConfigPainelChamadaState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects

        ]
    }



    private * configPainelChamadaReadAllEffects(actions: Payload) {

    }
}

export const configPainelChamadaController = new ConfigPainelChamadaController()

export const mapStateToConfigPainelChamadaProps = (state: ApplicationState) => ({
    configPainelChamadaState: state.configPainelChamadaState,
})

export const mapDispatchToConfigPainelChamadaProps = (dispatch: Dispatch) => ({
    configPainelChamadaActions: bindActionCreators({ ...configPainelChamadaController.reducer.actions }, dispatch),
})

export const handleSelecionarConfigPainelChamada = (set:boolean) => {
    store.dispatch(configPainelChamadaController.reducer.actions.setShowSelectModal(set));
    if(configPainelChamadaController.state.rows.length === 0)
        store.dispatch(configPainelChamadaController.reducer.actions.read())
}